/**
 * Figma-exported icon, tinted with currentColor so active and idle states share one file.
 * The path data stays the export; only the stroke color is rewritten.
 */
export function DsIcon({ svg, className }: { svg: string; className?: string }) {
  const html = svg
    .replace(/stroke="#[0-9A-Fa-f]{3,8}"/g, 'stroke="currentColor"')
    .replace('preserveAspectRatio="none"', 'preserveAspectRatio="xMidYMid meet"')
    .replace("<svg ", '<svg class="block size-full" ');
  return (
    <span
      className={className}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
